import { library } from '@fortawesome/fontawesome-svg-core';
import { faFolderPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { useAttachmentsPermissions } from '../../../../modules/attachments/Attachments.permissions';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { EnableFor } from '../../../containers/EnableForRole';
import { handleFolderNameChange } from '../../../helpers/formHelpers';
import { InputStatus } from '../../../models/error.model';

library.add(faFolderPlus);

interface IAddAttachmentFolderModalProps {
  isModalOpen: boolean;
  folderName: string;
  folderNameStatus: InputStatus;
  isLoading: boolean;
  toggleModal: () => void;
  onFolderNameChange: (id: string) => void;
  onAddFolderConfirmClicked: () => Promise<void>;
}

export const AttachmentAddFolder = observer((props: IAddAttachmentFolderModalProps): ReactElement => {
  const { t } = useTranslator();
  const permissions = useAttachmentsPermissions();

  return (
    <EnableFor hasPermission={permissions.canAddAttachments()}>
      <Button
        variant='outlined'
        onClick={props.toggleModal}
        startDecorator={<FontAwesomeIcon icon={faFolderPlus} />}
        loading={props.isLoading}
      >
        {t('attachment_add_folder')}
      </Button>
      <S_Modal
        isOpen={props.isModalOpen}
        toggle={props.toggleModal}
        headerText={t('attachment_create_folder')}
        buttons={
          <>
            <Button
              color='neutral'
              variant='outlined'
              loading={props.isLoading}
              onClick={props.toggleModal}
            >
              {t('cancel')}
            </Button>
            <Button
              onClick={() => {
                void props.onAddFolderConfirmClicked();
              }}
              loading={props.isLoading}
              disabled={!props.folderName || props.folderNameStatus.isValid === false}
            >
              {t('create')}
            </Button>
          </>
        }
      >
        <ValidatedTextInput
          type='text'
          value={props.folderName}
          labelText={t('attachment_add_folder_name')}
          placeholder=''
          onChange={handleFolderNameChange(props.onFolderNameChange)}
          feedbacks={props.folderNameStatus.errorCodes}
          isValid={props.folderNameStatus.isValid}
        />
      </S_Modal>
    </EnableFor>
  );
});
